var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset35(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 267.09 58.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1e0e00;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad_copy",
    "data-name": "sad copy"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 238.89,
    cy: 29.97,
    r: 28.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.21,
    cy: 28.21,
    r: 28.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset35);
export default __webpack_public_path__ + "static/media/Asset 35.78544640.svg";
export { ForwardRef as ReactComponent };